import { useEffect } from 'react';
import { useClientTokenManager } from '@cko/dashboard-shared';
import { HeapAPI, HeapEventPropertyKeys } from './HeapAPI';

export const useUpdateHeapTokenProperties = (isReady: boolean, api: HeapAPI) => {
  const { tokenProperties } = useClientTokenManager();
  const { userId, userRoles, userType } = tokenProperties;

  useEffect(() => {
    if (isReady) {
      api.addEventProperties({
        [HeapEventPropertyKeys.CKO_USER_ID]: userId,
        [HeapEventPropertyKeys.ROLE]: userRoles.join(),
        [HeapEventPropertyKeys.USER_TYPE]: userType,
      });
    }
  }, [isReady, api, userRoles, userId, userType]);
};
